import SingleSite from "./SingleSite";
import Authorization from "../../../../../generics/authorization";
import TabNavigation from "../../../../../common/TabNavigation";
import { getCookie } from "../../../../../serviceWorker";
import SubmenuHeaderView from "../../../SubmenuHeaderView";

const isUIConvergence = getCookie("cl-analytics");

const filterDashlets = isUIConvergence
  ? {
      filterDashlets: [
        {
          component: SubmenuHeaderView,
          name: "predictive-header",
          layout: { x: 0, y: 0, w: 12, h: 4 },
        },
      ],
    }
  : {
      filterDashlets: [
        {
          component: TabNavigation,
          name: "tab-nav",
          layout: { x: 0, y: 0, w: 12, h: 9 },
          style: { zIndex: 1 },
        },
      ],
    };

const pageProps = {
  ...filterDashlets,
  dashlets: [
    {
      component: SingleSite,
      name: "ad-ss-view",
      layout: { x: 0, y: 0, w: 12, h: 66 },
    },
  ],
};

const Page = () => <Authorization pageProps={pageProps} />;

export default Page;
